import React, { useState } from 'react'

import { useInView } from 'react-cool-inview'

import { bool, shape, string } from 'prop-types'

import BrowseAllButton from 'Pods/Shared/BrowseAllButton'
import i18n from 'Pods/Shared/I18n'

import CategoryHeader from './CategoryHeader'
import SubcategoriesGrid from './SubcategoriesGrid'

function CategoryCard({ category, extractingCoreStyles = false, locale = 'en' }) {
  const BrowseAllText = i18n.t('printModelPage.BrowseAllText', { ns: 'rails', lng: locale })
  const [hasObserved, setHasObserved] = useState(false)
  const { observe, inView } = useInView({
    rootMargin: '200px',
    unobserveOnEnter: true,
  })

  const renderCategoryContent = () => (
    <div className="categories-section__category">
      <CategoryHeader category={category} BrowseAllText={BrowseAllText}/>
      <SubcategoriesGrid subcategories={category.subcategories} />
      <BrowseAllButton
        href={category.path}
        text={BrowseAllText}
        className="categories-section__browse-all-mobile"
      />
    </div>
  )

  return (
    <div
      ref={(element) => {
        if (!hasObserved) {
          setHasObserved(true)
          observe(element)
        }
      }}
    >
      {(inView || extractingCoreStyles) && renderCategoryContent()}
      <noscript>{renderCategoryContent()}</noscript>
    </div>
  )
}

CategoryCard.propTypes = {
  category: shape({
    slug: string.isRequired,
    title: string.isRequired,
    description: string.isRequired,
  }).isRequired,
  extractingCoreStyles: bool,
  locale: string,
}

export default CategoryCard
